const breadCrumb = "Lotação de Servidores - Regime Complementar";

const routes = [
  {
    path: "/cadastro-minuta-portaria",
    name: "cadastro-minuta-portaria",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CadastroPortaria/CadastroMinutaPortaria/CadastroMinutaPortariaHome.vue"
      ),
  },
  {
    path: "/cadastro-minuta-portaria/novo",
    name: "cadastro-minuta-portaria-novo",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CadastroPortaria/CadastroMinutaPortaria/CadastroMinutaPortariaCad.vue"
      ),
  },
  {
    path: "/cadastro-minuta-portaria/editar/:id",
    name: "cadastro-minuta-portaria-editar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CadastroPortaria/CadastroMinutaPortaria/CadastroMinutaPortariaEdit.vue"
      ),
  },
  {
    path: "/cadastro-minuta-portaria/visualizar/:id",
    name: "cadastro-minuta-portaria-visualizar",
    meta: {
      requireAuth: false,
      breadCrumb: breadCrumb,
    },
    component: () =>
      import(
        "@/views/CadastroPortaria/CadastroMinutaPortaria/CadastroMinutaPortariaVisualizar.vue"
      ),
  },
];

export default routes;
